export default {"src":"/_next/static/media/LogoText.4aed2bc9.svg","height":73,"width":242,"blurWidth":0,"blurHeight":0};